import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import colorMapBotonBrillante from '../../../utils/colorMapBotonBrillante';
import styles from './BotonGrandeDinamico.module.css';

const BotonGrandeDinamico = ({
  texto = 'Click aquí',
  bgColor = 'blue',
  direccion = null,
  funcion = null,
  tipoBoton = 'button',
}) => {
  const navigate = useNavigate();

  const dirigirHacia = () => {
    navigate(direccion);
  };

  const colorElegido = colorMapBotonBrillante[bgColor];

  return (
    <button
      type={tipoBoton}
      className={clsx(
        `${styles[`${bgColor}-shine-background`]}
        px-6 py-2.5 text-gray-300 text-lg font-bold rounded-lg border-4 transition pixel-button hover:text-yellow-50 hover:shadow-lg w-full`,
        colorElegido.bg,
        colorElegido.border,
        colorElegido.hoverBg,
        colorElegido.hoverBorder,
        colorElegido.hoverShadow
      )}
      onClick={direccion != null ? dirigirHacia : funcion}
    >
      <span className="flex items-center justify-center gap-2">{texto}</span>
    </button>
  );
};

export default BotonGrandeDinamico;
